/**
 * Registration-link slugs for classes.
 *
 * Seasons are cloned from the previous one with the season added at the END
 * of the name ("... Independence Elementary Spring 2027"). The form used to
 * cut slugs at 50 characters, which on a long name dropped exactly the part
 * that tells two seasons apart: the clone got the original's link and could
 * not be saved. The backend column holds 100, so use all of it, and cut
 * between words when a name is longer still.
 */
export const SLUG_MAX_LENGTH = 100; // classes.slug is String(100)

export const slugFromClassName = (name) => {
  const slug = (name || "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
  if (slug.length <= SLUG_MAX_LENGTH) return slug;

  const cut = slug.slice(0, SLUG_MAX_LENGTH + 1);
  const lastBreak = cut.lastIndexOf("-");
  return (lastBreak > 0 ? cut.slice(0, lastBreak) : cut.slice(0, SLUG_MAX_LENGTH))
    .replace(/-+$/g, "");
};

/** Form data for a copy of an existing class, ready for "create". */
export const cloneClassForForm = (classData) => {
  const name = `${classData.name} (Copy)`;
  return {
    ...classData,
    id: undefined, // a new class, not an edit
    name,
    // The original's link must never ride along: slugs are unique, so the
    // copy could not be saved, and a hand-edited workaround hid the season.
    slug: slugFromClassName(name),
    current_enrollment: 0,
  };
};
